// National holidays, Proclamations 1006 (2026) and 1427 (2027); Eid dates require separate proclamations.
export const HOLIDAYS = [
  ["2026-01-01", "REGULAR", "New Year's Day"],
  ["2026-02-17", "SPECIAL", "Chinese New Year"],
  ["2026-03-20", "REGULAR", "Eid'l Fitr"],
  ["2026-04-02", "REGULAR", "Maundy Thursday"],
  ["2026-04-03", "REGULAR", "Good Friday"],
  ["2026-04-04", "SPECIAL", "Black Saturday"],
  ["2026-04-09", "REGULAR", "Araw ng Kagitingan"],
  ["2026-05-01", "REGULAR", "Labor Day"],
  ["2026-05-27", "REGULAR", "Eid'l Adha"],
  ["2026-06-12", "REGULAR", "Independence Day"],
  ["2026-08-21", "SPECIAL", "Ninoy Aquino Day"],
  ["2026-08-31", "REGULAR", "National Heroes Day"],
  ["2026-11-01", "SPECIAL", "All Saints' Day"],
  ["2026-11-02", "SPECIAL", "All Souls' Day"],
  ["2026-11-30", "REGULAR", "Bonifacio Day"],
  ["2026-12-08", "SPECIAL", "Feast of the Immaculate Conception"],
  ["2026-12-24", "SPECIAL", "Christmas Eve"],
  ["2026-12-25", "REGULAR", "Christmas Day"],
  ["2026-12-30", "REGULAR", "Rizal Day"],
  ["2026-12-31", "SPECIAL", "Last Day of the Year"],
  ["2027-01-01", "REGULAR", "New Year's Day"],
  ["2027-02-06", "SPECIAL", "Chinese New Year"],
  ["2027-03-25", "REGULAR", "Maundy Thursday"],
  ["2027-03-26", "REGULAR", "Good Friday"],
  ["2027-03-27", "SPECIAL", "Black Saturday"],
  ["2027-04-09", "REGULAR", "Araw ng Kagitingan"],
  ["2027-05-01", "REGULAR", "Labor Day"],
  ["2027-06-12", "REGULAR", "Independence Day"],
  ["2027-08-21", "SPECIAL", "Ninoy Aquino Day"],
  ["2027-08-30", "REGULAR", "National Heroes Day"],
  ["2027-11-01", "SPECIAL", "All Saints' Day"],
  ["2027-11-02", "SPECIAL", "All Souls' Day"],
  ["2027-11-30", "REGULAR", "Bonifacio Day"],
  ["2027-12-08", "SPECIAL", "Feast of the Immaculate Conception"],
  ["2027-12-24", "SPECIAL", "Christmas Eve"],
  ["2027-12-25", "REGULAR", "Christmas Day"],
  ["2027-12-30", "REGULAR", "Rizal Day"],
  ["2027-12-31", "SPECIAL", "Last Day of the Year"],
].map(([date, kind, name]) => ({ date, kind, name }));
